module.exports = __webpack_public_path__ + "static/Facebook-8-a30d55a73070e1601a13474f6e3daeec.png";